import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateProductPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.createProductPerk,
  {
    mutationKey: ['createProductPerk'],
  },
)
